import { FC, useEffect } from "react";

import { Header } from "components";
import YearPicker from "layouts/calendar-wrapper/year-picker";
import _ from "lodash";
import { useUrlState } from "utils";

interface YearHeaderProps {
  renderActions?: FC<{}>;
}

const YearHeader: FC<YearHeaderProps> = ({ renderActions: _renderActions }) => {
  const [currentView, setCurrentView] = useUrlState("view");

  useEffect(() => {
    if (!currentView) {
      setCurrentView("month");
    }
  }, [currentView, setCurrentView]);
  return (
    <Header
      renderActions={() => (
        <div className="flex items-center space-x-3">
          <div className="flex items-center">
            <YearPicker />
          </div>
          {_renderActions && (
            <>
              <div className="h-6 w-px bg-primary-300" />
              {_renderActions?.({})}
            </>
          )}
        </div>
      )}
    />
  );
};

export default YearHeader;
